import mock from "@/@fake-db/mock";

const GetCompanyFavicon =
    "https://staging.eaera.com//rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBZ2dUIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--b0f2a73878d993acd4ffe06240cc25d8848a1d4b/Logo%20Ro-%20Blk.png";

mock.onGet("/GetCompanyFavicon/data").reply(() => [200, GetCompanyFavicon]);
